<template>
    <div class="layout__container">

        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20px">

                <div class="text__align-center text__colour-white layout__margin__bottom-25px">
                    <div class="layout__padding-clear layout__width-80 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
                        <h2 class="text__colour-teal">You have successfully switched branches</h2>
                    </div>
                </div>
                <div class="layout__margin-20-0">
                    <div class="layout__width-100 text__align-center layout__position-left layout__margin-0-20">
                        <h3 classs="layout__padding-20-0">Your account has successfully been switched to <span class="text__colour-red">{{this.branchName}} ({{this.customerRef}})</span></h3>
                        <!--<h4>You are currently logged in as Branch: </h4>-->
                        <p class="layout__padding-20-0">You are now ordering for branch <span class="text__colour-red">{{this.branchName}} ({{this.customerRef}})</span></p>
                        <p> Any orders previously added to the <span class="text__colour-red">{{this.branchName}} ({{this.customerRef}})</span> basket have now been restored.</p>
                        <p class="layout__padding-20-0">You can return to any previous branch by simply using the Switch Branch button in the header</p>

                        <el-button
                                class="layout__margin-20-0 button-red button__base"
                                v-on:click="switchBranch">
                            Continue to Account Dashboard
                        </el-button>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Vue from 'vue';
    import Element from 'element-ui';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import Axios from 'axios';
    import Router from '../../router';

    Vue.use(Element);

    export default {
        name: "switchbranchconfirmation",
        mixins: [axios, dataFormatter],
        data() {
            return {
                customerRef: '',
                branchName: ''
            }
        },
        computed: {
        },
        created() {
            this.branchName = JSON.parse(this.returnCookie('_customer')).branchName
            this.customerRef = JSON.parse(this.returnCookie('_customer')).ref
        },
        mounted() {
        },
        methods: {
            switchBranch() {
                Router.push({
                    name: '/account/summary'
                });
            }
        }

    };
</script>